<template>
  <div>
    <el-row>
      <el-col>
        <!--
        <el-alert
          v-if="this.currentCompany === 'MTR'"
          title="Esta tabla muestra el ultimo registro creado por el proceso de corte y reconexion"
          type="info"
          effect="dark"
          show-icon
          :closable="false"
        ></el-alert>
        <el-alert
          v-else
          title="No se muestran registros de corte y reconexion para esta compañia"
          type="info"
          effect="dark"
          show-icon
          :closable="false"
        ></el-alert>
        -->
      </el-col>
    </el-row>

    <report-users-to-cut />
    <!--
    <rabbey-toolbox :filterables="true" @filter-search="handleSearch" />

    <rabbey-table3
      :data="renderItems"
      :columns="columns"
      :actions="actions"
      :laoding="loading"
      @rtable-push-action="handlePushAction"
    ></rabbey-table3>
-->
    <el-dialog :visible.sync="showDialog" :title="dialogTitle" width="60%">
      <rabbey-table3 :data="itemsRecord" :columns="columns" />
    </el-dialog>
  </div>
</template>

<script>
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import groupBy from "lodash/fp/groupBy";
import DatetimeFormatterVue from "@/components/functionals/DatetimeFormatter.vue";
import { filterItems } from "@/utils";
import MaintenanceRenderCheckVue from "@/components/functionals/MaintenanceRenderCheck.vue";
export default {
  name: "Record",
  created() {
    this.getItems();
  },
  data() {
    return {
      dialogTitle: "",
      itemsRecord: [],
      loading: false,
      showDialog: false,
      search: "",
      items: [],
      columns: [
        {
          "row-key": "id",
          prop: "id",
          label: "NO",
          width: 80,
          sortable: true,
          fix: true,
          align: "center"
        },
        {
          prop: "client_code",
          label: "Codigo de cliente",
          width: 180,
          sortable: true
        },
        {
          prop: "cut",
          label: "Cortado ?",
          width: 140,
          sortable: true,
          formatter: MaintenanceRenderCheckVue
        },
        {
          prop: "reconnection",
          label: "Reconectado ?",
          width: 140,
          sortable: true,
          formatter: MaintenanceRenderCheckVue
        },
        {
          prop: "create_at",
          label: "Fech. creacion",
          sortable: true,
          formatter: DatetimeFormatterVue,
          width: 140
        },
        {
          prop: "reason",
          label: "Razon",
          minWidth: 250
        }
      ],
      actions: [
        { command: "view-record", label: "Ver historial", icon: "el-icon-view" }
      ]
    };
  },
  computed: {
    renderItems() {
      let r = filterItems(this.search, this.groupItems, this.toggleLoading);
      return r;
    },
    groupItems() {
      const items = flow(
        groupBy("client_code"),
        map((records) => {
          // almacena el ultimo record
          const lastRecord = records[records.length - 1];
          // elimina el ultimo record
          records.splice(records.length - 1, 1);

          // arma el objeto agregando su children para el tree
          return {
            id: lastRecord.id,
            client_code: lastRecord.client_code,
            cut: lastRecord.cut,
            reconnection: lastRecord.reconnection,
            create_at: lastRecord.create_at,
            reason: lastRecord.reason,
            children: records
          };
        })
      )(this.items);
      return items;
    }
  },
  methods: {
    getItems() {
      this.loading = true;

      this.$http
        .get("/api/navixy/GetCutReconnectionRecord")
        .then((response) => {
          this.items = response.data;
        })
        .catch(console.error)
        .finally(() => (this.loading = false));
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    handleSearch(s) {
      this.search = s;
    },
    handlePushAction(action) {
      if (action.command === "view-record") {
        this.dialogTitle = `Historico del cliente ${action.row.client_code}`;
        this.itemsRecord = action.row.children;
        this.showDialog = true;
      }
    }
  },

  components: {
    "report-users-to-cut": () =>
      import(
        /* webpackChunkName: "ReportUsersToCut" */ "@/views/modules/technical_support/reports/ReportUsersToCut.vue"
      )
  }
};
</script>

<style></style>
